import React, { useState } from "react";
import classes from "./ContactInfo.module.css";

const ContactInfo = ({ onPrevious, onNext, formData, setFormData }) => {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.primaryPhone) newErrors.primaryPhone = "Primary phone number is required.";
    if (!formData.email) newErrors.email = "Email address is required.";
    if (!formData.preferredContactMethod) newErrors.preferredContactMethod = "Preferred contact method is required.";
    if (!formData.preferredLanguage) newErrors.preferredLanguage = "Preferred language is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext();
  };

  return (
    <div className={classes.container}>
      <form onSubmit={handleSubmit} className={classes.form}>
        
        {/* Contact Information */}
        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Contact Information</h3>

          <div className={classes.row2Col}>
            <div className={classes.inputGroup}>
              <label>Primary Phone Number <span className={classes.required}>*</span></label>
              <input
                type="text"
                name="primaryPhone"
                placeholder="Enter primary phone number"
                className={`${classes.formInput} ${errors.primaryPhone ? classes.inputError : ""}`}
                value={formData.primaryPhone || ""}
                onChange={handleChange}
              />
              {errors.primaryPhone && <span className={classes.errorText}>{errors.primaryPhone}</span>}
            </div>

            <div className={classes.inputGroup}>
              <label>Alternative Phone Number</label>
              <input
                type="text"
                name="alternativePhone"
                placeholder="Enter alternative phone number"
                className={classes.formInput}
                value={formData.alternativePhone || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className={classes.row2Col}>
            <div className={classes.inputGroup}>
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                className={`${classes.formInput} ${errors.email ? classes.inputError : ""}`}
                value={formData.email || ""}
                onChange={handleChange}
              />
              {errors.email && <span className={classes.errorText}>{errors.email}</span>}
            </div>

            <div className={classes.inputGroup}>
              <label>WhatsApp Number</label>
              <input
                type="text"
                name="whatsappNumber"
                placeholder="Enter WhatsApp number"
                className={classes.formInput}
                value={formData.whatsappNumber || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className={classes.row2Col}>
            <div className={classes.inputGroup}>
              <label>Preferred Contact Method <span className={classes.required}>*</span></label>
              <select
                name="preferredContactMethod"
                className={`${classes.formSelect} ${errors.preferredContactMethod ? classes.inputError : ""}`}
                value={formData.preferredContactMethod || ""}
                onChange={handleChange}
              >
                <option value="">Select contact method</option>
                <option>Phone Call</option>
                <option>SMS</option>
                <option>Email</option>
                <option>WhatsApp</option>
              </select>
              {errors.preferredContactMethod && <span className={classes.errorText}>{errors.preferredContactMethod}</span>}
            </div>

            <div className={classes.inputGroup}>
              <label>Preferred Contact Time</label>
              <select
                name="preferredContactTime"
                className={classes.formSelect}
                value={formData.preferredContactTime || ""}
                onChange={handleChange}
              >
                <option value="">Select preferred time</option>
                <option>Morning (8am - 12pm)</option>
                <option>Afternoon (12pm - 4pm)</option>
                <option>Evening (4pm - 8pm)</option>
              </select>
            </div>
          </div>
        </div>

        {/* Communication Preference */}
        {/* <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Communication Preference</h3>

          <div className={classes.inputGroup}>
            <label>Preferred Language</label>
            <select
              name="preferredLanguage"
              className={`${classes.formSelect} ${errors.preferredLanguage ? classes.inputError : ""}`}
              value={formData.preferredLanguage || ""}
              onChange={handleChange}
            >
              <option value="">Select preferred language</option>
              <option>English</option>
              <option>Yoruba</option>
              <option>Hausa</option>
              <option>Igbo</option>
              <option>French</option>
            </select>
            {errors.preferredLanguage && <span className={classes.errorText}>{errors.preferredLanguage}</span>}
          </div>

          <div className={classes.checkboxRow}>
            <label className={classes.checkboxLabel}>
              <input
                type="checkbox"
                name="smsNotifications"
                checked={formData.smsNotifications || false}
                onChange={handleChange}
              />
              Receive SMS Notifications
            </label>
            <label className={classes.checkboxLabel}>
              <input
                type="checkbox"
                name="emailNotifications"
                checked={formData.emailNotifications || false}
                onChange={handleChange}
              />
              Receive Email Notifications
            </label>
          </div>

          <div className={classes.checkboxRow}>
            <label className={classes.checkboxLabel}>
              <input
                type="checkbox"
                name="appointmentReminders"
                checked={formData.appointmentReminders || false}
                onChange={handleChange}
              />
              Receive Appointment Reminders
            </label>
          </div>
        </div> */}
        {/* Footer Navigation */}
        <div className={classes.footer}>
          <div className={classes.note}>
            Contact information will be used for appointments,
            notifications and other important patient communications.
          </div>
          <div className={classes.footerButtons}>
            <button type="button" className={classes.previousBtn} onClick={onPrevious}>
              ← Previous
            </button>
            <button type="submit" className={classes.nextBtn}>
              Next →
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactInfo;